<template>
  <b-modal
    :id="modalId"
    title="Добавление новой доверенности"
    size="md"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <div class="form-group">
      <label class="control-label">Добавление МЧД</label>
      <div class="row">
        <div class="col-md-6">
          <uppy-uploader
            :dashboard-show-condition="true"
            :document-id="1"
            :document-key="'power-of-attorney-doc-1'"
            :document-name="'Файл МЧД'"
            :document-need-expire="false"
            document-short-name="mchd_xml"
            :documents="documents1"
            :documents-show-condition="false"
            :entity-id="1"
            :entity-type="'user'"
            :files-request="filesRequest"
            :get-uuid="getUuid"
            :max-files-count="1"
            :mime-types="['application/xml', 'text/xml', 'text/plain']"
            :owner-type="'user'"
            :visible="true"
            @change="handleDocuments1Change"
          />
        </div>
        <div class="col-md-6">
          <uppy-uploader
            :dashboard-show-condition="true"
            :document-id="2"
            :document-key="'power-of-attorney-doc-2'"
            :document-name="'Файл подписи'"
            :document-need-expire="false"
            document-short-name="mchd_cades"
            :documents="documents2"
            :documents-show-condition="false"
            :entity-id="1"
            :entity-type="'user'"
            :files-request="filesRequest"
            :get-uuid="getUuid"
            :max-files-count="1"
            :mime-types="['*/*']"
            :owner-type="'user'"
            :visible="true"
            @change="handleDocuments2Change"
          />
        </div>
      </div>
    </div>
    <!-- Success message -->
    <div v-if="successMessage" class="alert alert-success">
      {{ successMessage }}
    </div>

    <!-- Error message -->
    <div v-if="errorMessage" class="alert alert-danger">
      {{ errorMessage }}
    </div>

    <template v-slot:modal-footer>
      <button type="button" class="btn btn-default" @click="closeModal">
        Отмена
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="savePowerOfAttorney"
        :disabled="!canSave || uploading"
      >
        <span v-if="uploading">
          <i class="glyphicon glyphicon-refresh glyphicon-spin"></i>
          Сохранение...
        </span>
        <span v-else>
          Сохранить доверенность
        </span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import UppyUploader from '@/common/components/inputs/UppyUploader.vue'
import { v4 as uuidv4 } from 'uuid'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'

export default {
  name: 'PowerOfAttorneyModal',

  components: {
    UppyUploader
  },

  data() {
    return {
      documents1: [],
      documents2: [],
      modalId: 'power-of-attorney-modal',
      uploading: false,
      errorMessage: '',
      successMessage: ''
    }
  },

  computed: {
    canSave() {
      return this.documents1.length > 0 && this.documents2.length > 0
    }
  },

  methods: {
    onModalShown() {
      this.$emit('show')
    },

    onModalHidden() {
      this.resetForm()
      this.$emit('hidden')
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
    },

    resetForm() {
      this.documents1 = []
      this.documents2 = []
    },

    handleDocuments1Change(documents) {
      this.documents1 = documents
    },

    handleDocuments2Change(documents) {
      this.documents2 = documents
    },

    getUuid() {
      return uuidv4()
    },

    filesRequest() {
      return Promise.resolve()
    },

    async savePowerOfAttorney() {
      if (!this.canSave) return

      function getExtension(file) {
        return '.' + file.split('.').pop()
      }

      this.uploading = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        const mchdUuid = this.documents1.length > 0 ? this.documents1[0].meta?.uuid_any : null
        const signatureUuid = this.documents2.length > 0 ? this.documents2[0].meta?.uuid_any : null

        if (!mchdUuid || !signatureUuid) {
          throw new Error('Оба файла (МЧД и подпись) должны быть загружены')
        }

        const formData = new FormData()
        formData.append('mchd_uuid', mchdUuid)
        formData.append('mchd_filename', mchdUuid + getExtension(this.documents1[0].meta.filename))
        formData.append('signature_uuid', signatureUuid)
        formData.append('signature_filename', signatureUuid + getExtension(this.documents2[0].meta.filename))

        const response = await ApiClient.uploadMchd(formData)

        const powerOfAttorneyData = {
          ...response.data
        }

        this.successMessage = 'Доверенность успешно сохранена!'
        this.$emit('save', powerOfAttorneyData)

        setTimeout(() => {
          this.closeModal()
        }, 1500)

      } catch (error) {
        console.error('Error uploading power of attorney:', error)
        this.errorMessage = error.response?.data?.message || error.message || 'Ошибка при загрузке доверенности'
      } finally {
        this.uploading = false
      }
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}

.control-label {
  font-weight: bold;
  margin-bottom: 10px;
  display: block;
}

.row {
  margin: 0 -15px;
}

.col-md-6 {
  padding: 0 15px;
}
</style>
